import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import projects from '../../projects.json'
import images from '../../images'
import Gallery from '../Gallery'
import colors, { pallete } from '../../colors'
import { breakpoints, theme } from '../../ui-config'

const iconDim = 52
const paddings = 28
const mobileBreak = 630

const FlexContainer = styled.div`
    display: flex;
`

const BackButton = styled(Link)`
    border-radius: 5px;
    padding: 12px 18px 16px 18px;
    background-color: ${colors.actionButton};
    color: ${colors.invertedText};
    position: fixed;
    left: 20px;
    top: calc(50vh - 14px);
    text-decoration: inherit;
    text-transform: uppercase;
    box-shadow: 0 3px 10px rgba(0,0,0,0.15);
    transition: box-shadow 100ms linear;
    @media print {
        display: none;
    }
    &:hover {
        box-shadow: 2px 6px 16px rgba(0,0,0,0.35);
    }
    @media (max-width: ${mobileBreak}px) {
        bottom: 20px;
        top: auto;
    }
`

const ProjectGalleryBuffer = styled.div`
    width: 100%;
    height: 250px;
`

const StyledProjectPage = styled.div`
    max-width: ${breakpoints.large}px;
    margin: 120px auto;
`

export const TagLine = styled.h1`
    color: ${theme.coloredHeaders};
    text-transform: uppercase;
    position: relative;
    top: -38px;
`

export const SubHeader = styled.h2`
    color: ${theme.coloredHeaders};
    text-transform: uppercase;
    margin-bottom: 2px;
`

export const QuoteCallout = styled.div`
    width: 100%;
    text-align: center
    font-weight: 500;
    text-decoration: italics;
`

export const TitleLine = styled.div`
    width: 70px;
    border-top: 3px solid ${theme.coloredHeaders};
    margin-bottom: 20px;
    position: relative;
    top: -40px;
`

export const SubHeaderLine = styled.div`
    width: 70px;
    border-top: 2px solid ${colors.text};
    position: relative;
    top: 2px;
    left: 1px;
`

export const MainImgContainer = styled.div`
    position: relative;
    margin: 0 0 8px 0;
    display: flex;
    overflow: hidden;
`

export const Disclaimer = styled.div`
    position: absolute;
    top: 50px;
    left: 20px;
    font-size: 2.2rem;
    color: ${colors.invertedText};
    text-shadow: 2px 2px 4px ${pallete.transparentGray}
`

export const MainImage = styled.img`
    width: 100%;
    padding-top: ${paddings}px;
`
//height: 100%;

export const Content = styled.div`
    display: block;
    flex-wrap: wrap;
    margin-top: 20px;
`

export const SmallContentInner = styled.div`
    max-width: 700px;
    margin: 0 auto;
`

export const TextContent = styled.div`
    flex: 1;
    margin-top: 20px;
    @media print {
        margin-top: 0;
    }
`

export const ImgContainerDigital = styled.div`
    margin-top: 10px;
    margin-left: 38px;
    padding-left: ${paddings}px;
    box-sizing: border-box;
    width: 320px;
    @media print {
        display: none;
    }

    @media (max-width: ${mobileBreak}px) {
        margin-left: 0;
        padding-left: 0;
        width: auto;
    }

`
export const ImgContainerPrint = styled.div`
    margin-left: 38px;
    padding-left: ${paddings}px;
    box-sizing: border-box;
    width: 320px;
    display: none;
    @media print {
        display: block;
    }
`
export const Image = styled.img`
    width: 100%;
`

export const ToolIcon = styled.div`
    width: ${iconDim}px;
    display: inline-block;
    vertical-align: top;
    margin: 6px 20px 6px 0;
    text-align: center;
`

export const ToolText = styled.span`
    font-size: 1.2rem;
    width: 100%;
`

export const IconImg = styled.img`
    width: ${iconDim}px;
`

export const SectionH3 = styled.h3`
   font-weight: 700;
   text-transform: uppercase;
   font-size: 2.5rem;
   color: ${theme.coloredHeaders};
`

export const SectionSpacer = styled.div`
    height: 12px;
`

export const TitleContainer = styled.div`
`

export const Title = styled.div`
    font-weight: 700;
    font-size: 3.4rem;
    color: ${colors.projectTitle};
`
// const Date = styled.div`
//     font-size: 1.5rem;
// `

export const Ul = styled.ul`
    line-height: 4rem;
`

export const FigureLabel = styled.span`
    display: block;
    font-size: 1.3rem;
    margin-bottom: 16px;
    margin-left: 2px;
`


export default class ProjectPage extends Component {
    render() {
        const { match, customProject } = this.props
        const { title } = match.params
        const project = projects.find(proj => proj.title.toLowerCase() === title.toLowerCase())
        if (typeof project === 'undefined' && typeof customProject === 'undefined') return null
        if (typeof project !== 'undefined') {
            project.figureTitles = project.figureTitles.length && !Array.isArray(project.figureTitles)
                ? JSON.parse(project.figureTitles)
                : project.figureTitles
        }

        return (
            <StyledProjectPage>
                { customProject ||
                <Content>
                    <TitleContainer>
                        <Title>{ project.title }</Title>
                    </TitleContainer>
                    <MainImgContainer>
                        <MainImage alt={ project.title } src={ images[project.projectMainImage]} />
                        { false && project.disclaimer ? <Disclaimer>*{ project.disclaimer }</Disclaimer> : null }
                    </MainImgContainer>
                    {
                        project.figureTitles.length
                            ? <FigureLabel>{ project.figureTitles[0] }</FigureLabel>
                            : <FigureLabel>Figure 1</FigureLabel>
                    }
                    <br />
                    <FlexContainer>
                        <TextContent>
                            { project.tagline.length ? <TagLine>{ project.tagline }</TagLine> : null }
                            <TitleLine />
                            <p dangerouslySetInnerHTML={{ __html: project.description }} />
                            <SectionSpacer />
                            {
                                project.identification.length
                                ? <div>
                                        <SubHeader>Identification</SubHeader>
                                        <SubHeaderLine />
                                        <p>{ project.identification }{ project.size ? `; ${project.size}` : null }</p>
                                        <SectionSpacer />
                                    </div>
                                : null
                            }
                            {
                                project.researchQuestions.length
                                    ? <div key="research">
                                        <SubHeader>Research Questions</SubHeader>
                                        <SubHeaderLine />
                                        <Ul>
                                            {
                                                JSON.parse(project.researchQuestions)
                                                .map((q, i) =>
                                                    <li key={ i }>{ q }</li>
                                                )
                                            }
                                        </Ul>
                                        <SectionSpacer />
                                    </div>
                                    : null
                            }

                            {
                                false && project.status.length
                                    ? <div key="status">
                                        <SubHeader>Status</SubHeader>
                                        <SubHeaderLine />
                                        <p>{ project.status }</p>
                                        <SectionSpacer />
                                    </div>
                                    : null
                            }

                            {
                                (false && project.outcomes.length && project.outcomes.toLowerCase() !== 'tbd')
                                    ? <div key="outcomes">
                                        <SubHeader>Outcomes</SubHeader>
                                        <SubHeaderLine />
                                        <p>{ project.outcomes }</p>
                                        <SectionSpacer />
                                    </div>
                                    : null
                            }

                            {
                                project.role.length
                                    ? <div key="key">
                                        <SubHeader>Responsibilities</SubHeader>
                                        <SubHeaderLine />
                                        <p>{ project.role }</p>
                                        <SectionSpacer />
                                    </div>
                                    : null
                            }

                            {
                                project.tools.length ?
                                    <div key="projects">
                                        <SubHeader>Tools</SubHeader>
                                        <SubHeaderLine />
                                        <br />
                                        {
                                            JSON.parse(project.tools).map(tool => {
                                                if (images[tool.toLowerCase().replace(/ /g, '').replace('3d', 'threed')]) {
                                                    return (
                                                        <ToolIcon key={ tool } >
                                                            <IconImg
                                                            title={ tool }
                                                            alt={ tool }
                                                            src={ images[tool.toLowerCase().replace(/ /g, '').replace('3d', 'threed')] }
                                                            />
                                                            <ToolText>{ tool }</ToolText>
                                                        </ToolIcon>
                                                    )
                                                } else {
                                                    return <ToolIcon key={ tool }>
                                                        <ToolText>
                                                        { tool }
                                                        </ToolText>
                                                    </ToolIcon>
                                                }
                                            })
                                        }
                                        <SectionSpacer />
                                    </div>
                                : null
                            }

                            {
                                project.references.length
                                    ? <div key="references">
                                        <SubHeader>References</SubHeader>
                                        <SubHeaderLine />
                                        <br />
                                            {
                                                JSON.parse(project.references)
                                                .map((ref, i) =>
                                                    <a key={ i} href={ ref }>{ ref }</a>
                                                )
                                            }
                                        <SectionSpacer />
                                    </div>
                                    : null
                            }

                        </TextContent>
                        {
                            project.secondaryImages.length
                            ? <ImgContainerDigital>
                                {
                                    JSON.parse(project.secondaryImages).map((img, i) =>
                                        <div>
                                            <Image key={ img } alt={ img } src={ images[img] } />
                                            {
                                                project.figureTitles.length
                                                    ? <FigureLabel>{ project.figureTitles[i+1] }</FigureLabel>
                                                    : <FigureLabel>{`Figure ${i+2}`}</FigureLabel>
                                            }
                                        </div>
                                    )
                                }
                            </ImgContainerDigital>
                            : null
                        }
                        {
                            project.secondaryImagesPrint.length
                            ? <ImgContainerPrint>
                                {
                                    JSON.parse(project.secondaryImagesPrint).map((img, i) =>
                                        <div>
                                            <Image key={ img + '_print'} src={ images[img] } />
                                            {
                                                project.figureTitles.length
                                                    ? <FigureLabel>{ project.figureTitles[i+1] }</FigureLabel>
                                                    : <FigureLabel>{`Figure ${i+2}`}</FigureLabel>
                                            }

                                        </div>
                                    )
                                }
                            </ImgContainerPrint>
                            : null
                        }

                    </FlexContainer>
                </Content>
                }
                <ProjectGalleryBuffer />
                <Gallery projects={projects} exclude={title} />
                <BackButton to="/">&#8592;</BackButton>
            </StyledProjectPage>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/projects/ProjectPage.js